import { initTutorial } from '../js/tutorial-shared/tutorial-core.js';

initTutorial({
  isVrPage: false,
  scheduleFrame: function (callback) {
    return window.requestAnimationFrame(callback);
  },
  cancelFrame: function (id) {
    window.cancelAnimationFrame(id);
  },
  waitFrame: function () {
    return new Promise(function (resolve) {
      window.requestAnimationFrame(resolve);
    });
  }
});
